import {EntityType, PropertyDefinition, PropertyDefinitionConfig} from '../types';

export const REPOSITORY_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idRepositoryRepository',
	singular: 'Collection',
};

export const REPOSITORY_REPOSITORY_TEMPLATE_PROPERTIES: PropertyDefinition[] = [{
	id: 'idRepositoryTemplateTitleProperty',
	parentId: REPOSITORY_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'title',
	label: 'Title',
	required: true,
	autoFocus: true,
}, {
	id: 'idRepositoryTemplateSingularProperty',
	parentId: REPOSITORY_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'singular',
	label: 'Singular',
	required: true,
}];
